<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
    <h1 class="text-3xl font-extrabold text-gray-900 mb-2 text-center">Privacy Policy</h1>
    <p class="text-sm text-gray-500 mb-8 text-center">Last Updated: August 30, 2025</p>

    <p class="text-gray-700 mb-8 leading-relaxed">
      Hector Investment LLC OPC Investment Institution ("Hector Investment LLC," "we," "us," or "our") is committed to protecting the privacy and security of your personal information. This Privacy Policy explains how we collect, use, share, and protect information when you visit our website,
      <a href="https://investdev.hectorinvestment.ai/" target="_blank" rel="noopener" class="text-blue-600 hover:underline">https://investdev.hectorinvestment.ai/</a> (the "Site"), and use our services.
    </p>

    <div class="space-y-6 text-gray-700 leading-relaxed">
      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">1. Information We Collect</h2>
        <ul class="list-disc list-inside space-y-2">
          <li>
            <strong>Personal Information:</strong> When you schedule a consultation, create an account, or contact us, you may provide us with personal details such as your name, email address, phone number, and preferred office location.
          </li>
          <li>
            <strong>Financial Information:</strong> If you proceed with an investment, we will collect necessary financial and identity verification information to comply with Know Your Customer (KYC) and Anti-Money Laundering (AML) regulations.
          </li>
          <li>
            <strong>Usage Data:</strong> We automatically collect information about your interaction with our Site, such as your IP address, browser type, pages visited, and the duration of your visit. This is collected through cookies and similar technologies.
          </li>
          <li>
            <strong>Calculator Data:</strong> Information entered into the ROI Calculator is used to provide you with a projection. We may analyze this data in an aggregated, anonymous form to improve our services.
          </li>
        </ul>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">2. How We Use Your Information</h2>
        <p>Your information is used to:</p>
        <ul class="list-disc list-inside space-y-2">
          <li>Provide, operate, and maintain our services, including your user account and dashboard.</li>
          <li>Schedule and conduct investment consultations.</li>
          <li>Process investment transactions and manage your portfolio.</li>
          <li>Communicate with you, respond to inquiries, and provide customer support.</li>
          <li>Comply with legal and regulatory obligations.</li>
          <li>Improve our website, services, and marketing efforts.</li>
        </ul>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">3. Information Sharing and Disclosure</h2>
        <p>We do not sell your personal information. We may share your information only in the following circumstances:</p>
        <ul class="list-disc list-inside space-y-2">
          <li>
            With trusted third-party service providers who assist us in operating our business (e.g., payment processors, compliance services), under strict confidentiality agreements.
          </li>
          <li>If required by law, regulation, or a valid legal process.</li>
          <li>To protect the rights, property, or safety of Hector Investment LLC OPC, our clients, or the public.</li>
        </ul>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">4. Data and Account Security</h2>
        <p>
          We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
        </p>
        <p>
          <strong>Your Responsibility:</strong> If you create an account on our Site to access our Dashboard or other services, you are responsible for maintaining the confidentiality of your account credentials, including your username and password. You agree not to share your credentials with any third party and to accept full responsibility for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account or any other breach of security.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">5. Your Rights</h2>
        <p>
          Depending on your jurisdiction, you may have the right to access, correct, or request the deletion of your personal data. To make such a request, please contact us at the relevant office email address provided on our Site.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">6. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">7. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us via the details listed on our contact us Section or by the below Address</p>
        <p>
          Address: 1st Floor, Hanging Garden Tower - 4 Al Nahlah St - Al Danah - Zone 1 - Abu Dhabi
        </p>
        <p>Email: info hector-ae.com</p>
      </section>
    </div>
  </div>
</div>